import React from 'react';
// @mui
import { Container } from '@mui/material';
// components
import Preloader from '../components/Preloader';
import { Helmet } from 'react-helmet-async';
import config from '../config';
import AdminDashboardContent from './dashboards/AdminDashboardContent';
import MerchantDashboardContent from './dashboards/MerchantDashboardContent';

// ----------------------------------------------------------------------

export default class DashboardAppPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {},
            error: null
        };
    }
    componentDidMount() {
        const { server } = this.props.context.getState();
        server.users.dashboardInfo().then((data) => {
            this.setState({
                data: data,
                isLoading: false
            });
        });
    }

    render() {
        let role = this.state.data ? localStorage.systemRole : '';
        if (this.state.isLoading) {
            return <Preloader />;
        }
        const title = config.title
            ? `Dashboard | ${config.title}`
            : 'Dashboard';
        return (
            <>
                <Helmet>
                    <title>{title}</title>
                </Helmet>

                <Container maxWidth="xl">
                    {role === 'appz' && (
                        <AdminDashboardContent
                            {...this.props}
                            data={this.state.data}
                        />
                    )}
                    {role === 'merchant' && (
                        <MerchantDashboardContent
                            {...this.props}
                            data={this.state.data}
                        />
                    )}
                    {role === 'psp' && (
                        <AdminDashboardContent
                            {...this.props}
                            data={this.state.data}
                        />
                    )}
                </Container>
            </>
        );
    }
}
